import React, { useMemo, useRef, useState } from "react"
import CountriesImg from "../../../../../assets/avia/sidebar/countries.png"
import FlagAustria from "../../../../../assets/avia/sidebar/austria.png"
import SearchInput from "./SearchInput"
import CircularCheckbox from "../ui/CircularCheckbox"
import ShowMore from "./ShowMore"
import { NUMBER_OF_VIEWS } from "../../utils/variables/sidebar"
import ItemsFlexWrapper from "./ItemsFlexWrapper"
import { FlagIcon } from "react-flag-kit"
import { toggleId } from "../../utils/filters/common"
import { motion, AnimatePresence } from "framer-motion"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import {
  selectAviaCountryById,
  selectSelectedCountries,
  toggleSelectAllAviaCountries,
} from "../../../../../app/reducers/book/aviaSearchSlice"
import { cn } from "../../../../../lib"
import { useInitialSelectedId } from "../../hooks/useInitialSelectedId"
import AnimatedList from "./AnimatedList"
import { useClickOutside } from "../../hooks"

const Countries = ({ countries, onChange, initialSelectedCountryIds }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  //selectros

  // states
  const [showAllCountries, setShowAllCountries] = useState(false)
  const [search, setSearch] = useState("")

  //
  const sectionRef = useRef(null)

  useClickOutside(sectionRef, () => setShowAllCountries(false))

  const selectedCount = useMemo(() => {
    return countries.filter((country) => country.is_selected).length
  }, [countries])

  const isAllSelected = useMemo(() => {
    return selectedCount === countries.length && countries.length > 0
  }, [selectedCount, countries.length])

  const filteredCountries = useMemo(() => {
    const query = search.toLowerCase()

    return [...countries].sort((a, b) => {
      const aMatch =
        a.country.toLowerCase().includes(query) || a.country_code.toLowerCase().includes(query)
      const bMatch =
        b.country.toLowerCase().includes(query) || b.country_code.toLowerCase().includes(query)

      if (aMatch && !bMatch) return -1
      if (!aMatch && bMatch) return 1

      return a.country.localeCompare(b.country)
    })
  }, [countries, search])

  return (
    <div ref={sectionRef} className="mb-6 relative">
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-1">
          <img src={CountriesImg} alt="countries icon" className="w-4 h-4" />
          <span className="text-dark-gray text-lg font-medium">
            {t("filter_excursion_result.states")}
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex gap-2 items-center">
          <SearchInput value={search} onChange={(e) => setSearch(e.target.value)} />
          <label className="flex items-center gap-1.5 px-2">
            <motion.input
              type="checkbox"
              checked={isAllSelected}
              onChange={() => onChange("all")}
              className="w-4 h-4 border-gray-300 rounded accent-second-success focus:ring-second-success cursor-pointer"
              whileTap={{ scale: 0.8 }}
              animate={{ scale: isAllSelected ? 1.2 : 1 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            />
            <span className="text-xs text-gray-700 whitespace-nowrap">
              {t("admin.log.status.select.all")}
            </span>
          </label>
        </div>
        <ItemsFlexWrapper>
          {filteredCountries?.map((country, index) => {
            const shouldShow = showAllCountries || index < NUMBER_OF_VIEWS

            return (
              <AnimatedList
                key={country.country_code}
                isVisible={shouldShow}
                index={index}
                delayFromIndex={index >= NUMBER_OF_VIEWS ? 0.03 : 0}
              >
                <CircularCheckbox isSelected checked={country.is_selected}>
                  <button
                    onClick={() => onChange(country.country_code)}
                    className={cn(
                      "ml-2 text-dark-gray text-[15px] flex items-center gap-1 hover:bg-gray-50 rounded-xl transition relative disabled:cursor-not-allowed disabled:after:absolute disabled:after:inset-0 disabled:after:flex disabled:after:items-center disabled:after:justify-center disabled:after:text-xl disabled:opacity-60"
                    )}
                    disabled={initialSelectedCountryIds.includes(country.country_code)}
                  >
                    <FlagIcon
                      code={
                        country.country_code === "vt" ? "VN" : country.country_code.toUpperCase()
                      }
                      size={14}
                    />
                    <span className="text-gray-700 text-[15px]">{country.country}</span>
                  </button>
                </CircularCheckbox>
              </AnimatedList>
            )
          })}
        </ItemsFlexWrapper>
      </div>

      {countries.length > NUMBER_OF_VIEWS && (
        <ShowMore
          showAll={showAllCountries}
          onClick={() => setShowAllCountries(!showAllCountries)}
        />
      )}
      <div className="absolute -bottom-3 left-0 right-0 border-b border-light-gray/25"></div>
    </div>
  )
}

export default Countries
